import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
/* IMPORT HERE */

const topbarHeight = '40px';
const topbarHeightNumber = Number.parseInt(topbarHeight, 10);

const editor: ThemeUICSSObject = {
  '.editor__top': {
    height: topbarHeight,
    borderBottom: '1px solid',
    borderBottomColor: 'palette.border.section',

    '.editor__topToolbar': {
      display: 'flex',
      gap: 2,
      p: 2,
    },
  },
  '.editor__main': {
    display: 'flex',
    justifyContent: 'stretch',
    position: 'fixed',
    top: topbarHeight,
    left: 0,
    right: 0,
    bottom: responsive({ 0: 'unset', 4: 0 }),
    width: responsive({ 0: 'unset', 4: '375px' }),

    '& > *': {
      height: `calc(100vh - ${topbarHeight})`,
      overflow: 'auto',
    },

    '& > div:last-of-type': {
      width: '100%',
    },
  },

  '.colorHistory': {
    flexShrink: 0,
    height: topbarHeight,
    p: 2,
    display: 'flex',
    gap: 2,
    position: 'sticky',
    bottom: 0,
    background: 'palette.background.paper',

    '.colorHistory__individual': {
      height: `${topbarHeightNumber - 8}px`,
      width: `${topbarHeightNumber - 8}px`,
      p: 2,
      border: '1px solid',
      borderColor: 'palette.border.field',
      overflow: 'hidden',
    },

    '.colorHistory__individual__coloredSquare': {
      width: '100%',
      height: '100%',
    },
  },

  '.editor__datagrids': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(5),
  },

  '.editor__datagrid__secondarygrid': {
    width: '100%',

    table: {
      width: '100%',
    },
  },

  '.editor__toolbar__hamburguer': {
    display: responsive({ 0: 'inline-flex', 4: 'none' }),
  },

  '.editor__toolbar': {
    position: responsive({ 0: 'fixed', 4: 'relative' }),
    zIndex: 'menu',
    inset: responsive({
      0: `${topbarHeightNumber + 5}px 5px 5px 5px`,
      4: 'unset',
    }),
    flexShrink: 0,
    width: responsive({ 0: 'auto', 4: '375px' }),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.border.section',
    borderTop: 'none',
    overflow: 'auto',
    height: `calc(100vh - ${topbarHeight})`,
    justifyContent: 'space-between',

    '.collapsiblePanel__content': {
      pl: spacing(3),
      borderLeft: '1px solid',
      borderLeftColor: 'palette.border.article',
    },
  },

  '.editor__controlsTree': {
    display: 'flex',
    flexDirection: 'column',
  },

  '.editor__preview': {
    backgroundColor: 'palette.background.default',
    overflow: 'auto',
    position: 'fixed',
    left: responsive({ 0: 0, 4: '375px' }),
    right: 0,
    top: topbarHeight,
    bottom: 0,
  },

  '.editor__preview__container': {
    maxWidth: '900px',
    p: 7,
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },

  '.editor__control__label__tools': {
    display: 'flex',
    gap: 2,
    width: 'min-content',

    '& > *': {
      height: '27px',
      width: '27px',
      flexShrink: 0,
    },
  },

  '.editor__control__label': {
    flexDirection: 'column',
    pt: spacing(3),
    pl: spacing(3),
    pr: spacing(3),

    '& > div': {
      alignItems: 'start',
      border: '1px solid',
      borderColor: 'palette.border.article',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      width: '100%',
      p: spacing(3),
    },

    '.editor__colorpicker__alpha': {
      display: 'flex',
      gap: spacing(3),
      alignItems: 'center',
    },

    '.editor__colorpicker': {
      height: '27px',
      width: '27px',
      p: 0,
    },

    '.arrayControl__buttons': {
      display: 'flex',
      gap: spacing(2),
    },

    '.arrayControl__entries': {
      display: 'flex',
      gap: spacing(2),
      overflow: 'auto',
      maxWidth: '100%',
      pb: 2,

      input: {
        p: 1,
        fontSize: 12,
        flexBasis: '30px',
        flexShrink: 0,
        textAlign: 'center',
        border: 'none',
      },
    },

    '&.editor__control__numberArray': {
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        overflow: 'hidden',

        '.control__entries': {
          flexBasis: '100%',
        },

        '.editor__control__labelbox': {
          flexBasis: 'max-content',
        },

        '.editor__control__content': {
          flexShrink: 0,
          width: 'max-content',
          p: 0,
          maxWidth: '100%',
          overflow: 'hidden',
          gap: 2,
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
  },

  '.editor__control__labelbox': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: spacing(3),
    width: '100%',

    '& > *': {
      flexShrink: 0,
    },

    '&:hover .iconButton': { opacity: 1 },

    '.iconButton': {
      variant: 'buttons.icon-outline',
      opacity: 0,
      transition: 'opacity 200ms',

      svg: {
        height: 'iconSm',
        width: 'iconSm',
      },
    },
  },

  '.editor__tree__wrapper': {
    '& > .collapsiblePanel__label:hover .iconButton': { opacity: 1 },

    '& > .collapsiblePanel__label .iconButton': {
      variant: 'buttons.icon-outline',
      opacity: 0,
      transition: 'opacity 200ms',

      svg: {
        height: 'iconSm',
        width: 'iconSm',
      },
    },

    '.collapsiblePanel__label': {
      pr: spacing(3),
    },
  },

  '.editor__control__content': {
    p: spacing(3),
    width: '100%',

    '& > *': {
      width: '100%',
    },
  },

  '.color__picker__wrapper': {
    width: '27px',
    height: '27px',
    border: '1px solid',
    borderColor: 'palette.border.field',
    p: '3px',
    overflow: 'hidden',

    '.color__picker__color__preview': {
      width: '100%',
      height: '100%',

      border: '1px solid',
      borderColor: 'palette.border.article',
    },
  },

  '.editor__preview__form': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(5),
  },

  '.editor__preview__form__grid': {
    variant: 'grids.default',
    gridTemplateColumns: responsive({ 0: 'unset', 4: 'repeat(4, 1fr)' }),
  },

  '.editor__preview__form__buttons': {},
};

export default editor;
